import { observer } from "mobx-react";
import Pagination from "react-js-pagination";
import Moment from "react-moment";
import {
  useSubscriptionStore,
  SubscriptionStore,
  SubscriptionStoreContext,
} from "./store/SubscriptionStore";
import Filter from "./SubscriptionFilter/subscriptionfilter";
import { BiDollarCircle } from "react-icons/bi";
import { useEffect, useState } from "react";
import { RxEyeOpen } from "react-icons/rx";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuthStore } from "../Auth/store/Auth";

// const SubscriptionManagement = () => {
//   const [searchParams] = useSearchParams();
//   const currentPage = searchParams.get("page") || 1;

//   const store = new SubscriptionStore({
//     isloading: true,
//     pagginationcount: currentPage,
//   });
//   return (
//     <SubscriptionStoreContext.Provider value={store}>
//       <Screen />
//     </SubscriptionStoreContext.Provider>
//   );
// };

// export default SubscriptionManagement;

const SubscriptionManagement = observer(() => {
  const navigate = useNavigate();
  const {Token} = useAuthStore();
  const [searchParams] = useSearchParams();
  const searchParamPage = searchParams.get("page");
  const [currentPage, setCurrentPage] = useState(searchParams.get("page") || 1);
  const [emptyinput,setemptyinput] = useState(false)
  useEffect(() => {
    setCurrentPage(searchParamPage ?? 1);
  }, [searchParamPage]);

  useEffect(() => {
    setActivePage(searchParamPage ?? 1);
    setIndexPage(searchParamPage ?? 1);
  }, [currentPage]);

  const {
    totalPremiumAmount,
    loadTableData,
    setActivePage,
    setIndexPage,
    getFilterSubscriptions,
    NofilterwithPagination,
    getSubscriptions,
    indexPage,
    filtertrue,
    filterVisibility,
    activePage,
    perPage,
    Count,
    Subscriptions,
    loadSubscriptions,
    nolist,
    setToken
  } = useSubscriptionStore();

  /**
   * useEffect to get the category list with currrentPage from url params
   */
  useEffect(() => {
    if (searchParamPage) {
      const page = Number(searchParamPage ?? 1);
      setCurrentPage(page);
      setIndexPage(page);
    }
  }, [searchParamPage]);

  const handlePageChange = (pageNumber) => {
    NofilterwithPagination(true);
    const element = document.getElementById("tablescroll");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    console.log(" setfiltertrue(false)", filtertrue);
    if (!filtertrue) {
      getFilterSubscriptions(pageNumber,Token);
      setIndexPage(pageNumber);
      setActivePage(pageNumber);
    } else {
      if (filterVisibility === true) {
        getSubscriptions(pageNumber,Token);
        setActivePage(pageNumber);
        setIndexPage(pageNumber);
      } else {
        setActivePage(pageNumber);
        setIndexPage(pageNumber);
      }
    }

    /**
     * if selected page is not 1 then navigate to the selected page adn ad dpageNumber to url
     */
    if (Number(pageNumber) + 1 !== 1) {
      navigate(`?page=${Number(pageNumber)}`);
      setActivePage(Number(pageNumber));
    } else {
      navigate("");
    }
  };
   useEffect(() => {
    setToken(Token)
    getSubscriptions(searchParams.get("page") || 1,Token);
  }, []);
  return (
    <>
      <div className="flex justify-between">
        <div className=" mb-4">
          <p className=" text-2xl font-semibold text-moredarkgreen">
            Subscription Report
          </p>
          {/* <p className=" opacity-80 text-sm">Home / User</p> */}
        </div>
        <div className=" mb-4">
          <p className=" text-l font-semibold text-moredarkgreen">
            Total Premium Amount: ${totalPremiumAmount}
          </p>
          {/* <p className=" opacity-80 text-sm">Home / User</p> */}
        </div>
      </div>
      <Filter emptyinput={emptyinput}/>
      <button
      onClick={()=> {
        navigate("orders");
      }}
        className="btn btn-md bg-darkgreen text-[#fff] text-sm hover:text-darkgreen hover:bg-lightgreen flex items-center ml-auto"
      >
        <RxEyeOpen className="mr-1" />
        View all Transaction
      </button>
      <div className="card bg-base-100 shadow-md p-6 mt-8 overflow-auto">
        <div className="overflow-x-auto w-full">
          <table className="table table-zebra w-full">
            <thead>
              <tr>
                <th>S.no</th>
                <th>Subscription ID</th>
                <th>Amount</th>
                <th>Customer</th>
                <th>Plan</th>
                <th>Payment Method</th>
                <th>Order Date</th>
                <th className="whitespace-normal">Subscription Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody id="tablescroll" className="text-sm relative">
              {loadSubscriptions && (
                <>
                  <tr>
                    <td colSpan={9} className="animate-pulse py-6"></td>
                  </tr>
                  <tr>
                    <td colSpan={9} className="animate-pulse py-6"></td>
                  </tr>
                  <tr>
                    <td colSpan={9} className="animate-pulse py-6"></td>
                  </tr>
                  <tr>
                    <td colSpan={9} className="animate-pulse py-6"></td>
                  </tr>
                  <tr>
                    <td colSpan={9} className="animate-pulse py-6"></td>
                  </tr>
                </>
              )}

              {Subscriptions &&
                Subscriptions.map((res, index) => (
                  <tr key={index}>
                    <td> {perPage * (indexPage - 1) + (index + 1)}</td>
                    <td className=" capitalize">#{res?.subscription_id}</td>
                    <td className=" capitalize">${res?.amount}</td>
                    <td className=" capitalize">
                      <span className=" font-bold">
                        {res?.user?.first_name}
                      </span>
                      <p className="capitalize text-xs">
                        {res?.user?.phone_number}
                      </p>
                    </td>
                    <td className=" capitalize">
                      {res?.payment_cycle ?? "N/A"}{" "}
                      {/*theme_display_name change as per api*/}
                    </td>
                    <td className=" capitalize">
                      {res?.payment_method ?? "-"}
                    </td>
                    <td className=" capitalize">
                      <Moment format="MM/DD/YYYY">
                        {res.subscription_start_date ?? "N/A"}
                      </Moment>
                    </td>
                    <th>
                      <label
                        // title="Change Status"
                        // htmlFor="my-modal-5"
                        className={`btn capitalize ${
                          res?.subscription_status === "RENEWED" ||
                          res?.subscription_status === "SUBSCRIBED"
                            ? "bg-green hover:bg-green"
                            : "bg-error hover:bg-error"
                        }  text-[#000] border-hidden  btn-xs`}
                        // onClick={(e) => {
                        // }}
                      >
                        {res?.subscription_status}
                      </label>
                    </th>
                    <td className=" text-base">
                      <div className="flex items-center space-x-4">
                        <Link
                          title="View Subscriptions"
                          to={`/subscriptionsmanagement/orders/${res?.id}`}
                        >
                          <RxEyeOpen />
                        </Link>
                      </div>
                    </td>
                  </tr>
                ))}
              {nolist && (
                <tr>
                  <td colSpan={9} className="my-10 text-center">
                    <BiDollarCircle className=" text-[#dedede] text-8xl mx-auto" />
                    <p className=" font-semibold text-lg">
                      No Subscriptions Found
                    </p>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          <Pagination
            activePage={activePage}
            containerClassName={"pagination"}
            itemsCountPerPage={perPage}
            totalItemsCount={Number(Count)}
            pageRangeDisplayed={10}
            onChange={handlePageChange}
          />
          {/* status change model start */}
          {/* <input type="checkbox" id="my-modal-5" className="modal-toggle" />
          <div className="modal">
            <div className="modal-box relative">
              <label
                htmlFor="my-modal-5"
                className="btn btn-sm btn-circle absolute right-2 top-2"
              >
                ✕
              </label>
              <h3 className="text-lg font-bold text-center">
                Are you sure you want to change Status?
              </h3>
              <div className="modal-action justify-center">
                <label
                  htmlFor="my-modal-5"
                  className="btn btn-md bg-green text-[#000] text-sm hover:text-green hover:bg-[#000] ml-4"
                >
                  Yes
                </label>
                <label htmlFor="my-modal-5" className="btn btn-md bg-[#000] text-green text-sm hover:bg-[#000]">
                  No
                </label>
              </div>
            </div>
          </div> */}
          {/* status change model end */}
        </div>
      </div>
    </>
  );
});
export default SubscriptionManagement